import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19ebc3c2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=19ebc3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebc3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ebc3c2')) {
      api.createRecord('19ebc3c2', component.options)
    } else {
      api.reload('19ebc3c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19ebc3c2&scoped=true&", function () {
      api.rerender('19ebc3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/storeInfo/basics/index.vue"
export default component.exports